import React, { useEffect, useState, useRef } from 'react';
import * as echarts from 'echarts';
import { format, parse, endOfDay } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function GraficoDetalheAnimal({ tipoGrafico, dadosAnimal }) {
    const graficoVendedorDiario = 1;
    const graficoExcelenciaMensal = 2;

    let dadosGrafico;
    
    if (tipoGrafico == graficoVendedorDiario){
        dadosGrafico = dadosAnimal.graficoDiario ? dadosAnimal.graficoDiario : [];
    }

    if (tipoGrafico == graficoExcelenciaMensal){
        dadosGrafico = dadosAnimal.graficoExcelenciaMensal ? dadosAnimal.graficoExcelenciaMensal : [];
    }
    
    const graficoRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 768px)').matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const handleMediaChange = (e) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener('change', handleMediaChange);

        if (dadosGrafico && dadosGrafico.length > 0)
            gerarGrafico(isMobile);

        return () => {
            mediaQuery.removeEventListener('change', handleMediaChange);
        };
    }, [isMobile]);

    function formatarMoeda(valor) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    function gerarGrafico(isMobileParametro) {

        var chart = echarts.getInstanceByDom(graficoRef.current);

        if (!chart) {
            chart = echarts.init(graficoRef.current);
        }

        let eixoX;
        let eixoY;
        let tooltip;
        let yAxis;

        if (tipoGrafico === graficoVendedorDiario) {
            eixoX = dadosGrafico ? dadosGrafico.map(item => item.dia) : [];
            eixoY = dadosGrafico ? dadosGrafico.map(item => item.totalpresente) : [];
            tooltip = {
                trigger: 'axis',
                formatter: function (params) {
                    const valor = params[0].data;
                    const valorFormatado = formatarMoeda(valor);
                    return `<div style="text-align: center;">
                                <div>${diaDaSemana(params[0].name)}</div>
                                <div>Valor: ${valorFormatado}</div>
                            </div>`;
                },
            }
            yAxis = {
                type: 'value',
                axisLabel: {
                    color: 'white',
                    fontFamily: 'Arial',
                    fontSize: 12,
                    formatter: function (value) {
                        return formatarMoeda(value);
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.5)',
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.2)',
                    },
                },
            }
        }

        if (tipoGrafico === graficoExcelenciaMensal) {
            eixoX = dadosGrafico ? dadosGrafico.map(item => item.agrupador) : [];
            eixoY = dadosGrafico ? dadosGrafico.map(item => item.nivel_indice) : [];
            const nivel = dadosGrafico ? dadosGrafico.map(item => item.nivel) : [];
            const pontuacao = dadosGrafico ? dadosGrafico.map(item => item.pontuacao) : [];
            tooltip = {
                trigger: 'axis',
                formatter: function (params) {
                    return `<div style="text-align: center;">
                                <div>Nível: ${nivel[params[0].dataIndex]}</div>
                                <div>Pontuação: ${pontuacao[params[0].dataIndex]}</div>
                            </div>`;
                },
            }
            yAxis = {
                type: 'value',
                min: 0,
                max: 4,
                interval: 1,
                axisLabel: {
                    color: 'white',
                    fontFamily: 'Arial',
                    fontSize: 12,
                    formatter: function (value) {
                        switch (value) {
                            case 4:
                                return 'A';
                            case 3:
                                return 'B';
                            case 2:
                                return 'C';
                            case 1:
                                return 'D';
                            case 0:
                                return 'E';
                            default:
                                return ''; 
                        }
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.5)',
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.2)',
                    },
                },
            }
        }

        const option = {
            tooltip: tooltip,

            xAxis: {
                backgroundColor: 'black',
                type: 'category',
                data: eixoX,
                backgroundColor: 'black',
                axisLabel: {
                    color: 'White',
                    fontFamily: 'Arial',
                    fontSize: 12,
                },
            },

            yAxis: yAxis,

            series: [
                {
                    data: eixoY,
                    name: 'Email',
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                        color: 'rgb(47, 51, 253)',
                        width: 3,
                    },
                    itemStyle: {
                        color: 'rgb(47, 51, 253)',
                    },
                    areaStyle: {
                        color: 'rgba(255, 255, 255, 0.1)',
                    },

                },
            ],

            grid: {
                left: '1%',
                right: '1%',
                bottom: '3%',
                containLabel: true,
            },
        };

        if (isMobileParametro) {
            chart.setOption({
                dataZoom: [
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                        zoomLock: true,
                        height: 10,
                        bottom: 0,
                        start: 0,
                        end: 50,
                        handleSize: 0,
                        showDetail: false,
                        showDataShadow: false,
                    },
                    {
                        type: 'inside',
                        id: 'insideX',
                        xAxisIndex: 0,
                        start: 0,
                        end: 50,
                        zoomOnMouseWheel: false,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: true,
                    },
                ]
            }, { replaceMerge: 'dataZoom' });


        } else {
            chart.setOption({
                dataZoom: []
            }, { replaceMerge: 'dataZoom' });
        }

        chart.setOption(option);

        window.addEventListener('resize', () => {
            chart.resize();
        });

        return () => {
            chart.dispose();
        };
    }

    function mesAtual() {
        const meses = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const [mes, ano] = dadosAnimal.mesAno.split('-');
        const mesAtual = mes - 1;
        const anoAtual = ano;

        return `${meses[mesAtual]} de ${anoAtual}`;
    }

    function diaDaSemana(data) {

        const [mes, ano] = dadosAnimal.mesAno.split('-');

        const dataGrafico = endOfDay(parse(`${ano}-${mes}-${data}`, 'yyyy-MM-dd', new Date()));

        const diaDaSemana = format(dataGrafico, 'EEEE', { locale: ptBR });

        const diaDaSemanaFormatado = diaDaSemana.charAt(0).toUpperCase() + diaDaSemana.slice(1);

        return diaDaSemanaFormatado
    }

    function tituloGrafico() {

        let titulo;

        if (tipoGrafico === graficoVendedorDiario) {
            titulo = 'Gráfico de progresso diário em ' + dadosAnimal.animal + ' (' + mesAtual() + ')'
        }

        if (tipoGrafico === graficoExcelenciaMensal) {
            titulo = 'Gráfico de progresso anual em ' + dadosAnimal.animal + ' (' + mesAtual() + ')'
        }

        return titulo;
    }

    return (
        <section className="py-12 bg-gradient-to-b from-gray-c22 to-white">
            <div className="container">
                <div className="mb-16">
                    <div className="font-poppins font-semibold text-[26px] text-gray-c5 text-center">
                        <h2>{tituloGrafico()}</h2>
                    </div>
                    <div className="mt-8">
                        {(dadosGrafico && dadosGrafico.length > 0) ? (
                            <div ref={graficoRef} style={{ width: '100%', height: '300px', borderRadius: '10px', background: 'black' }}></div>
                        ) : (
                            <p style={{ textAlign: 'center' }}>Dados diários não encontrados para o mês e ano atuais!</p>
                        )
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GraficoDetalheAnimal;
